import { render } from "./BookingUpsellSuccess.vue?vue&type=template&id=58048fc0"
import script from "./BookingUpsellSuccess.vue?vue&type=script&lang=js"
export * from "./BookingUpsellSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingUpsellSuccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58048fc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58048fc0', __exports__)) {
    api.reload('58048fc0', __exports__)
  }
  
  module.hot.accept("./BookingUpsellSuccess.vue?vue&type=template&id=58048fc0", () => {
    api.rerender('58048fc0', render)
  })

}


export default __exports__